import { Expose } from "../../serialization/class-transformer";

export class ServiceDataObjectDto {
    
    @Expose()
    public objectName: string;

}